import { render, staticRenderFns } from "./Curriculo_TokenCpf.vue?vue&type=template&id=44c612c3&scoped=true"
import script from "./Curriculo_TokenCpf.vue?vue&type=script&lang=js"
export * from "./Curriculo_TokenCpf.vue?vue&type=script&lang=js"
import style0 from "./Curriculo_TokenCpf.vue?vue&type=style&index=0&id=44c612c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c612c3",
  null
  
)

export default component.exports